import React from 'react';
import { GameEquipment } from '../Game_Equiment';

function EquipmentPanelComponent({
  player,
  draggedItem,
  inventoryActionsDisabled = false,
  inventoryActionsDisabledReason = '',
  onDragStart,
  onDrop,
}) {
  return (
    <div className="equipment-panel">
      <GameEquipment
        inventoryActionsDisabled={inventoryActionsDisabled}
        inventoryActionsDisabledReason={inventoryActionsDisabledReason}
        userEquipment={player?.equipment}
        onDragStart={onDragStart}
        onDrop={onDrop}
        draggedItem={draggedItem}
      />
    </div>
  );
}

const EquipmentPanel = React.memo(EquipmentPanelComponent);

export default EquipmentPanel;
